import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { PrimaryViewConfig } from '../types';
import { PrimaryViewContent } from './primary-view-content';
import { PrimaryViewFooter } from './primary-view-footer';
import { PrimaryViewHeader } from './primary-view-header';

interface Props {
  children?: ReactNode;
  primaryViewConfig?: PrimaryViewConfig;
  onAction: () => void;
  onBack: () => void;
  onClose: () => void;
}

export const PrimaryView = ({ children, primaryViewConfig, onAction, onBack, onClose }: Props) => {
  if (!children && !primaryViewConfig) {
    return null;
  }

  if (children) {
    return <div css={containerStyles}>{children}</div>;
  }

  return (
    <div css={containerStyles}>
      <ListBoxPrimaryView.Header title={primaryViewConfig?.title || ''} onBack={onBack} onClose={onClose} />
      <ListBoxPrimaryView.Content>{primaryViewConfig?.content}</ListBoxPrimaryView.Content>
      <ListBoxPrimaryView.Footer
        primaryButtonTrackingId={primaryViewConfig?.primaryButtonTrackingId}
        cancelButtonTrackingId={primaryViewConfig?.cancelButtonTrackingId}
        primaryButtonLabel={primaryViewConfig?.primaryLabel}
        loading={primaryViewConfig?.isLoading}
        disabled={primaryViewConfig?.isDisabled}
        onAction={onAction}
        onCancel={onBack}
      />
    </div>
  );
};

export const ListBoxPrimaryView = Object.assign(PrimaryView, {
  Header: PrimaryViewHeader,
  Content: PrimaryViewContent,
  Footer: PrimaryViewFooter,
});

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.colors.white,
  borderRadius: theme.borderRadius.large,
  boxShadow: theme.shadows.floating,

  // @TODO: Revisit these dimensions as per design
  minWidth: 356,
  maxWidth: 356,
});
